import React from 'react';
import ChangeSettingForm from '../ChangeSettingForm';

const ChangeNickName = () => (
    <ChangeSettingForm
        label="Nickname"
        endpoint="/api/c/changenickname/"
        apiParamName="nickname"
        reduxField="nickname"
        required={false}
        hint="Leave blank to remove your nickname."
    />
);

export default ChangeNickName;
